import classNames from 'classnames'
import type {KeyboardEventHandler} from 'react'
import * as React from 'react'
import {useEffect, useRef} from 'react'

import type {AgentPoolProjectsTreeProjectItem, ToggleExpandHandler} from '../../AgentPoolPage.types'
import styles from '../ProjectsTab.css'

type Props = {
  projectItem: AgentPoolProjectsTreeProjectItem
  onToggleExpand: ToggleExpandHandler
  className?: string
  children: React.ReactNode
  onKeyDown?: KeyboardEventHandler<HTMLDivElement>
  focused?: boolean
}

export default function ProjectRow({
  projectItem,
  onToggleExpand,
  className,
  children,
  onKeyDown,
  focused,
}: Props): React.ReactElement | null {
  const onClick = React.useCallback(() => {
    onToggleExpand(projectItem.rawId, !projectItem.expanded)
  }, [projectItem.expanded, onToggleExpand, projectItem.rawId])
  const ref = useRef<HTMLDivElement>(null)
  useEffect(() => {
    if (focused) {
      ref.current?.focus()
    }
  }, [focused])

  return (
    <div
      ref={ref}
      tabIndex={0}
      data-test="projects-list-item"
      className={classNames(className, styles.tableRow, {
        [styles.expandableTableRow]: projectItem.expandable,
      })}
      key={projectItem.rawId}
      role="row"
      aria-expanded={projectItem.expandable ? projectItem.expanded === true : undefined}
      onClick={projectItem.expandable ? onClick : undefined}
      onKeyDown={onKeyDown}
    >
      {children}
    </div>
  )
}
